<!--新增行号-->
<template>
  <e-dialog
    :dialog-title="contactId ? '编辑联系人' : '新增联系人'"
    :center-dialog-visible="visible"
    :popup-width="'800px'"
    @resetPopupData="handleCancel"
    @submitPopupData="handleConfirm"
  >
    <div v-loading="loading">
      <!-- <el-cascader :props="props" collapse-tags="true"></el-cascader> -->
      <el-form ref="form" :model="formData" :rules="rules" label-width="120px">
        <!-- 102: 销售联系人 110：财务联系人） -->
        <el-form-item label="联系人类型:" prop="businessDirection">
          <el-radio-group
            v-model="formData.businessDirection"
            :disabled="defaultContactType"
          >
            <el-radio label="102">销售联系人</el-radio>
            <el-radio label="110">财务联系人</el-radio>
            <el-radio label="101">采购联系人</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 联系人类型（101：默认、102：非默认 -->
        <el-form-item label="是否默认:" prop="contactType">
          <el-radio-group
            v-model="formData.contactType"
            :disabled="defaultContactType"
          >
            <el-radio label="101">是</el-radio>
            <el-radio label="102">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="text-box">
          默认销售联系人将作为您开展石化相关业务时的唯一联系人使用，将向石化内部系统进行同步，请谨慎修改。
        </div>
        <el-form-item label="创建模式:" prop="createType">
          <el-radio-group v-model="formData.createType">
            <el-radio label="1">关联易派客账号作为联系人</el-radio>
            <el-radio label="2">创建新的联系人信息，不关联易派客账号</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="formData.createType != '2'"
          style="width: 50%"
          label="员工账号:"
          prop="memberName"
        >
          <el-autocomplete
            v-model="formData.memberName"
            :fetch-suggestions="querySearchMemberName"
            placeholder="请输入员工账号"
            :debounce="1000"
            @select="handleSelectMemberName"
            @change="handleChangeMemberName"
          ></el-autocomplete>
        </el-form-item>

        <el-form-item
          style="width: 50%; display: inline-block"
          label="联系人姓名:"
          prop="contacts"
        >
          <el-autocomplete
            v-if="formData.createType === '1'"
            v-model="formData.contacts"
            :debounce="1000"
            :fetch-suggestions="querySearchRealName"
            placeholder="请输入联系人姓名"
            @select="handleSelectRealName"
            @change="handleChangeRealName"
          ></el-autocomplete>
          <el-input
            v-if="formData.createType === '2'"
            v-model="formData.contacts"
          ></el-input>
        </el-form-item>
        <el-form-item
          style="width: 50%; display: inline-block"
          label="联系人电话:"
          prop="mobile"
        >
          <el-input
            v-model="formData.mobile"
            :disabled="formData.createType == '1'"
          ></el-input>
        </el-form-item>
        <el-form-item
          style="width: 50%; display: inline-block"
          label="电子邮箱:"
          prop="email"
        >
          <el-input
            v-model="formData.email"
            :disabled="formData.createType == '1'"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="formData.businessDirection == '110'"
          style="width: 50%; display: inline-block"
          label="邮寄地址:"
          prop="address"
        >
          <el-input v-model="formData.address"></el-input>
        </el-form-item>
        <el-form-item
          v-if="formData.businessDirection == '110'"
          style="width: 50%; display: inline-block"
          label="邮政编码:"
          prop="postcode"
        >
          <el-input v-model="formData.postcode"></el-input>
        </el-form-item>
        <el-form-item
          v-if="formData.businessDirection === '102'"
          label="负责类目:"
        >
          <el-cascader
            ref="cascader"
            :key="propsKey"
            v-model="formData.productTypeContent"
            style="width: 500px"
            :placeholder="productChecked ? '全部类别' : '请选择负责类目'"
            :options="treeData"
            :props="props"
            :filter-method="dataFilter"
            filterable
            collapse-tags
            :disabled="productChecked"
            @change="caChange"
          ></el-cascader>
          <el-checkbox
            v-model="productChecked"
            style="margin-left: 20px"
            @change="handleProductChecked"
            >全部类别</el-checkbox
          >
        </el-form-item>
        <el-form-item
          v-if="formData.businessDirection === '102'"
          label="负责区域:"
        >
          <el-cascader
            ref="areaCascader"
            :key="areapropsKey"
            v-model="formData.salesAreaContent"
            style="width: 500px"
            :placeholder="areaChecked ? '全部区域' : '请选择负责区域'"
            :options="areaTreeData"
            :props="areaProps"
            :filter-method="areaDataFilter"
            filterable
            :disabled="areaChecked"
            collapse-tags
            @change="areaCaChange"
          ></el-cascader>
          <el-checkbox
            v-model="areaChecked"
            style="margin-left: 20px"
            @change="handleAreaChecked"
            >全部区域</el-checkbox
          >
        </el-form-item>
        <el-form-item
          v-if="formData.businessDirection === '102'"
          label="负责客户:"
          prop="customerContent"
        >
          <eui-btn
            v-if="!companyListStr"
            :disabled="customerChecked"
            type="secondary"
            @click="handleCustomerChecked"
          >
            请选择
          </eui-btn>
          <eui-btn v-else type="text" @click="handleCustomerChecked">{{
            companyListStr
          }}</eui-btn>
          <el-checkbox v-model="customerChecked" style="margin-left: 20px"
            >全部客户</el-checkbox
          >
        </el-form-item>
        <el-form-item label="备注:" prop="remark">
          <el-input
            v-model="formData.remark"
            type="textarea"
            :rows="4"
            placeholder="请输入内容"
            maxlength="200"
            show-word-limit
          >
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <select-customer-dialog
      v-if="chooseVisible"
      ref="selectCustomerDialog"
      :choose-visible="chooseVisible"
      :company-id-list="companyIdList"
      :purchase-company-info="purchaseCompanyInfo"
      :purchase-company-id-list="queryData.purchaseCompanyIdList"
      :supplier-company-info="supplierCompanyInfo"
      :supplier-company-id-list="queryData.supplierCompanyIdList"
      :select-name-flag="selectNameFlag"
      :company-info="companyInfo"
      @closeDialog="closeDialog"
      @handleQueryCompany="handleQueryCompany"
    >
    </select-customer-dialog>
  </e-dialog>
</template>

<script>
import EDialog from '@/components/common/e-dialog.vue';
import {
  mobile,
  email,
  postalCode,
} from '@/modules/projectA/utils/verification';
import api from '@/modules/projectA/api/organization/index';
import selectCustomerDialog from './selectCustomerDialog';
import Api from '../../api/maintenanceContact';

export default {
  name: 'AddContactDialog',
  components: {
    EDialog,
    selectCustomerDialog,
  },
  data() {
    const mobileReg = /^0?(11|12|13|15|16|17|18|19|14)[0-9]{9}$/;
    // 手机号验证
    const mobile = (rule, value, callback) => {
      console.log(value);
      if (value === '') {
        callback(new Error('请输入手机号'));
      } else if (!mobileReg.test(value)) {
        callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    };
    const emailReg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
    // 邮箱验证
    const email = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入邮箱'));
        return;
      }
      if (Number(this.formData.createType) === 2) {
        if (!emailReg.test(value)) {
          callback(new Error('请输入正确的邮箱'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      defaultContactType: false,
      contactId: '',
      // 解决 v-model值改变后 选择没改变的问题  只要model改变 propsKey就改变
      propsKey: 1000,
      treeData: [],
      valueModel: [],
      loading: false,
      visible: false,
      formData: {
        businessDirection: '110',
        contactType: '102',
        createType: '1',
        productTypeContent: [],
        salesAreaContent: [],
        email: '',
        mobile: '',
        contacts: '',
      },
      rules: {
        businessDirection: [
          {
            required: true,
            message: '请选择联系人类型',
            trigger: 'change',
          },
        ],
        contactType: [
          {
            required: true,
            message: '请选择是否默认',
            trigger: 'change',
          },
        ],
        createType: [
          {
            required: true,
            message: '请选择创建模式',
            trigger: 'change',
          },
        ],
        memberName: [
          {
            required: true,
            message: '请输入员工账号',
            trigger: 'blur',
          },
        ],
        contacts: [
          {
            required: true,
            message: '请输入联系人姓名',
            trigger: 'blur',
          },
        ],
        mobile: [
          {
            required: true,
            validator: mobile,
            trigger: ['blur', 'change'],
          },
        ],
        email: {
          required: true,
          validator: email,
          trigger: ['blur', 'change'],
        },
        address: [
          {
            required: true,
            message: '请输入邮寄地址',
            trigger: 'blur',
          },
        ],
        postcode: [
          {
            required: true,
            validator: postalCode,
            trigger: ['blur', 'change'],
          },
        ],
        productTypeContent: [
          {
            required: true,
            message: '请输入类目',
            trigger: 'change',
          },
        ],
        salesAreaContent: [
          {
            required: true,
            message: '请输入区域',
            trigger: 'change',
          },
        ],
      },
      templateSelection: {
        bankNumber: '',
        bankName: '',
      },
      restaurants: [],
      timeout: null,
      salesAreaOptions: [],

      emailDisabled: false,
      mobileDisabled: false,
      memberNameList: [],
      realNameList: [],

      props: {
        children: 'children',
        label: 'categoryName',
        value: 'mdmCategoryCode',
        multiple: true,
        expandTrigger: 'hover',
        emitPath: false, // 通过最后一级的id回显
      },
      areapropsKey: 1000,
      areaTreeData: [],
      areaProps: {
        children: 'cityList',
        label: 'areaName',
        value: 'areaId',
        multiple: true,
        expandTrigger: 'hover',
        emitPath: false, // 通过最后一级的id回显
      },
      areaValueModel: [],
      productChecked: true,
      areaChecked: true,
      customerChecked: true,
      chooseVisible: false,
      selectNameFlag: 'supplierCompanyIdList',
      companyIdList: [],
      purchaseCompanyInfo: [],
      supplierCompanyInfo: [],
      queryData: {
        purchaseCompanyIdList: [],
        supplierCompanyIdList: [],
      },
      companyListStr: '',
    };
  },

  created() {},

  mounted() {
    this.getCategoryTree();
    this.getAreaTree();
  },

  methods: {
    initData(contactId, companyName, customerCompanyList) {
      this.visible = true;
      this.loading = true;
      this.formData = {
        businessDirection: '110',
        contactType: '102',
        createType: '1',
        productTypeContent: [],
        salesAreaContent: [],
      };
      if (contactId !== '') {
        this.contactId = contactId;
        this.defaultContactType = false;
        this.companyInfo = {
          companyName,
          itemId: contactId,
        };
        this.supplierCompanyInfo = customerCompanyList;
        this.getContactInfo(contactId, companyName);
      } else {
        this.supplierCompanyInfo = [];
        this.customerChecked = true;
        this.companyListStr = '';
        this.contactId = '';
        this.loading = false;
        this.defaultContactType = false;
        this.productChecked = true;
        this.areaChecked = true;
        this.customerChecked = true;
      }
    },
    // 获得联系人信息
    async getContactInfo(contactId) {
      const query = {
        contactId,
      };
      const info = await Api.getContactDetail(query);
      if (info.success) {
        const contactInfo = info.data;

        if (contactInfo.contactType === '101') {
          this.defaultContactType = true;
        }
        // 回填创建模式
        if (contactInfo.memberId !== undefined) {
          contactInfo.createType = '1';
        } else {
          contactInfo.createType = '2';
        }
        // 防止修改联系人及邮箱
        this.emailDisabled = true;
        this.mobileDisabled = true;

        if (contactInfo.businessDirection === '102') {
          if (contactInfo.customerDesc === '全部客户') {
            this.customerChecked = true;
            this.companyListStr = '';
          } else {
            this.customerChecked = false;
            const arr = this.formatCustomerDesc(contactInfo.customerDesc);
            this.companyListStr = `${arr[0]}等${arr.length - 1}家`;
          }
          if (contactInfo.isDefaultSelectProductType === 1) {
            this.productChecked = true;
            contactInfo.productTypeContent = [];
          } else {
            this.productChecked = false;
            console.log(
              contactInfo.productTypeContent,
              'contactInfo.productTypeContent'
            );
            // 重新赋值类目及区域
            contactInfo.productTypeContent =
              contactInfo.productTypeContent !== null &&
              contactInfo.productTypeContent !== undefined &&
              typeof contactInfo.productTypeContent === 'string' &&
              contactInfo.productTypeContent !== ''
                ? contactInfo.productTypeContent.split(',')
                : [];
          }

          if (contactInfo.isDefaultSelectSalesArea === 1) {
            this.areaChecked = true;
            contactInfo.salesAreaContent = [];
          } else {
            this.areaChecked = false;
            contactInfo.salesAreaContent =
              contactInfo.salesAreaContent !== null &&
              contactInfo.salesAreaContent !== undefined &&
              typeof contactInfo.salesAreaContent === 'string' &&
              contactInfo.salesAreaContent !== ''
                ? contactInfo.salesAreaContent.split(',')
                : [];
          }
        }

        // 重新赋值地区
        this.formData = contactInfo;

        if (contactInfo.businessDirection === '102') {
          setTimeout(() => {
            this.caChange();
            this.areaCaChange();
          }, 0);
        }
      }
      this.loading = false;
    },
    // 把这个格式"联合产品测接口用,陕西银天物流有限公司,中国石化销售有限公司河南石油分公司," 转换成数组
    formatCustomerDesc(customerDesc) {
      // 如果customerDesc为空，则返回空数组
      if (!customerDesc) {
        return [];
      }
      return customerDesc.split(',');
    },
    // 提交
    handleConfirm() {
      console.log(this.formData);
      this.$refs.form.validate(async (valid) => {
        console.log(this.formData);
        // mobile已经有值了但是验证还是以为空 所以需要手动触发验证
        this.$refs.form.validateField(['mobile', 'email']);
        if (valid) {
          console.log(this.formData);
          if (
            !this.productChecked &&
            this.formData.productTypeContent.length === 0
          ) {
            this.$message.error('请选择类目');
            return false;
          }
          if (
            !this.areaChecked &&
            this.formData.salesAreaContent.length === 0
          ) {
            this.$message.error('请选择类目');
            return false;
          }

          const query = { ...this.formData };
          if (this.productChecked) {
            query.isDefaultSelectProductType = 1;
            delete query.productTypeContent;
          } else {
            query.isDefaultSelectProductType = 0;
          }
          if (this.areaChecked) {
            query.isDefaultSelectSalesArea = 1;
            delete query.salesAreaContent;
            delete query.salesAreaContentDesc;
          } else {
            query.isDefaultSelectSalesArea = 0;
          }
          if (query.businessDirection === '102'||query.businessDirection === '101') {
            let productList = [];
            const areaList = [];
            const areaTextList = [];
            if (!this.productChecked) {
              this.tableData.map((item) => {
                productList.push(item.mdmCode);
                return true;
              });
            } else {
              const product = [];
              this.treeData.map((item) => {
                product.push(item.categoryCode);
                return true;
              });

              productList = product;
            }
            if (!this.areaChecked) {
              this.areaTableData.map((item) => {
                areaList.push(item.areaId);
                areaTextList.push(item.areaName);
                return true;
              });
            }

            query.productTypeContent = String(productList);
            query.salesAreaContent = String(areaList) || '全部区域';
            query.salesAreaContentDesc = String(areaTextList) || '全部区域';
            if (this.customerChecked) {
              query.customerCompanyList = [];
              query.customerDesc = '全部客户';
            } else {
              query.customerCompanyList = this.supplierCompanyInfo;
              query.customerDesc = '';
            }
          }
          query.companyId = JSON.parse(
            localStorage.getItem('USERINFO')
          ).companyId;
 console.log(query, 'query');
          // 去除提交字段的空格
          const newList = JSON.stringify(query, function (key, value) {
            if (key !== '') {
              if (typeof value === 'string') {
                return value.replace(/\s+/g, '');
              }
            }
            return value;
          });

          const newQuery = JSON.parse(newList);

          if (newQuery.businessDirection === '110') {
            delete newQuery.productTypeContent;
            delete newQuery.salesAreaContent;
            delete newQuery.salesAreaContentDesc;
          }

          const info = await Api.saveContactDetail(newQuery);
          if (info.success) {
            this.$emit('getList');
            this.visible = false;
          }
        }
        return valid;
      });
    },
    handleCancel() {
      this.visible = false;
      this.formData = {
        businessDirection: '110',
        contactType: '',
        createType: '',
      };
    },
    // 模糊查询员工账号
    getSelectMemberResult(text) {
      return new Promise((resolve) => {
        const query = {
          companyId: this.$store.state.USERINFO.companyId,
          memberName: text,
        };
        const info = Api.typeAheadContactMemberInfo(query);
        resolve(info || []);
      });
    },
    // 模糊查询联系人
    getSelectRealResult(text) {
      return new Promise((resolve) => {
        const query = {
          companyId: this.$store.state.USERINFO.companyId,
          realName: text,
        };
        const info = Api.typeAheadContactMemberInfo(query);
        resolve(info || []);
      });
    },
    handleSelectMemberName(item) {
      console.log(item);
      if (item.email !== '' && item.email !== undefined) {
        // this.formData.email = item.email;
        this.$set(this.formData, 'email', item.email);
        this.emailDisabled = true;
      } else {
        // this.formData.email = '';
        this.$set(this.formData, 'email', '');
      }

      if (item.mobile !== '' && item.mobile !== undefined) {
        //  this.formData.mobile = item.mobile;
        this.$set(this.formData, 'mobile', item.mobile);
        this.mobileDisabled = true;
      } else {
        // this.formData.mobile = '';
        this.$set(this.formData, 'mobile', '');
      }
      if (item.realName !== '' && item.realName !== undefined) {
        this.formData.contacts = item.realName;
      }
      if (item.memberId !== '' && item.memberId !== undefined) {
        this.formData.memberId = item.memberId;
      }
      this.$forceUpdate();
      // 手动触发表单验证
      this.$nextTick(() => {
        this.$refs.form.validateField(['mobile', 'email']);
      });
    },

    // 选择员工账号
    handleChangeMemberName() {
      if (
        this.memberNameList.length === 1 &&
        this.memberNameList[0].id === '-1'
      ) {
        this.formData.email = '';
        this.formData.mobile = '';
        this.formData.contacts = '';
        this.emailDisabled = false;
        this.mobileDisabled = false;
      }
    },

    // 判断员工是不是空搜索
    checkMemberNameList(list) {
      const newList = [...list];
      if (newList.length === 0) {
        this.formData.email = '';
        this.formData.mobile = '';
        this.formData.contacts = '';
        this.emailDisabled = false;
        this.mobileDisabled = false;
      }
      this.$forceUpdate();
    },

    // 搜索联系人
    handleSelectRealName(item) {
      if (item.email !== '' && item.email !== undefined) {
        this.formData.email = item.email;
        this.emailDisabled = true;
      }
      if (item.mobile !== '' && item.mobile !== undefined) {
        this.formData.mobile = item.mobile;
        this.mobileDisabled = true;
      }
      if (item.memberName !== '' && item.memberName !== undefined) {
        this.formData.memberName = item.memberName;
        this.formData.memberId = item.memberId;
      }
      this.$forceUpdate();
      // 手动触发表单验证
      this.$nextTick(() => {
        this.$refs.form.validateField(['mobile', 'email']);
      });
    },
    // 选择联系人
    handleChangeRealName() {
      if (this.realNameList.length === 1 && this.realNameList[0].id === '-1') {
        this.formData.email = '';
        this.formData.mobile = '';
        this.formData.memberName = '';
        this.formData.memberId = '';
        this.emailDisabled = false;
        this.mobileDisabled = false;
      }
    },
    // 判断联系人是不是空搜索
    checkRealNameList(list) {
      const newList = [...list];
      if (newList.length === 0) {
        this.formData.email = '';
        this.formData.mobile = '';
        this.formData.memberName = '';
        this.formData.memberId = '';
        this.emailDisabled = false;
        this.mobileDisabled = false;
      }
      this.$forceUpdate();
    },
    // 员工账号的模糊查询
    async querySearchMemberName(queryString, cb) {
      if (queryString && queryString.length > 0) {
        try {
          const data = await this.getSelectMemberResult(queryString);
          // 赋值给建议列表，渲染到页面
          let list = data.data || [];
          this.memberNameList = list;
          this.checkMemberNameList(list);
          // 如果list.length等于0，则代表没有匹配到结果。手动给list添加一条提示信息
          if (list.length === 0) {
            list.push({
              id: '-1',
              value: '无匹配结果',
            });
            // 调用 callback 返回建议列表的数据
            cb(list);
          } else {
            list = list.map((item) => {
              const newItem = item;
              newItem.id = item.memberId;
              newItem.value = item.memberName;
              return newItem;
            });
            list = list.filter((item) => {
              return item.value.indexOf(queryString) > -1;
            });
            // 调用 callback 返回建议列表的数据
            cb(list);
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    // 联系人姓名的模糊查询
    async querySearchRealName(queryString, cbr) {
      if (queryString && queryString.length > 0) {
        try {
          const data = await this.getSelectRealResult(queryString);
          // 赋值给建议列表，渲染到页面
          let list = data.data || [];
          this.realNameList = list;
          this.checkRealNameList(list);
          // 如果list.length等于0，则代表没有匹配到结果。手动给list添加一条提示信息
          if (list.length === 0) {
            list.push({
              id: '-1',
              value: '无匹配结果',
            });
            // 调用 callback 返回建议列表的数据
            cbr(list);
          } else {
            list = list.map((item) => {
              const newItem = item;
              newItem.id = item.memberId;
              newItem.value = item.realName;
              return newItem;
            });
            console.log(list);
            list = list.filter((item) => {
              return item.value.indexOf(queryString) > -1;
            });
            // 调用 callback 返回建议列表的数据
            console.log(list);
            cbr(list);
          }
        } catch (error) {
          console.log(error);
        }
      }
    },

    // 获得类目
    async getCategoryTree() {
      const result = await api.queryApplyCategoryTree();
      if (result.code === '200') {
        this.treeData = this.setTreeRecursion(result?.data);
      }
    },

    setTreeRecursion(data) {
      data.map((item) => {
        item.disabled = !!item.applyFlag;
        if (item.children && item.children.length !== 0) {
          this.setTreeRecursion(item.children);
        }
        return true;
      });
      return data || [];
    },

    dataFilter(node, val) {
      console.log('val', val, 'node', node);
      if (node.label.indexOf(val) !== -1 && !node.hasChildren) {
        return true;
      }
      return false;
    },

    caChange() {
      const data = this.$refs.cascader.getCheckedNodes();
      console.log(data, 'caChange');
      const lastLevelData = data.filter((el) => !el.hasChildren);
      console.log(lastLevelData, 'lastLevelData');
      /*
        data: 源数据,
        pathNodes: 所有父级对象
      */
      const tableData = [];
      const valueModel = [];
      lastLevelData.forEach((el) => {
        const obj = {};
        const arr = [];
        obj.categoryName = el.label;
        obj.mdmCode = el.data.mdmCategoryCode;
        tableData.push(obj);
        valueModel.push(arr);
      });
      // if (tableData.length > 100) {
      //   this.$message.warning('产品目录申请数量最多100条');
      //   tableData = tableData.slice(0, 100);
      // }

      this.tableData = [...tableData];
      this.cloneTableData = JSON.parse(JSON.stringify(tableData));
      console.log(this.tableData, 'this.tableData');
    },

    // 负责区域
    async getAreaTree() {
      const result = await Api.listChinaProvinceAndCity();
      if (result.success) {
        this.areaTreeData = this.areaSetTreeRecursion(result?.data);
      }
    },

    areaSetTreeRecursion(data) {
      data.map((item) => {
        item.disabled = !!item.applyFlag;
        if (item.children && item.children.length !== 0) {
          this.areaSetTreeRecursion(item.children);
        }
        return true;
      });
      return data || [];
    },

    areaDataFilter(node, val) {
      console.log('val', val, 'node', node);
      if (node.label.indexOf(val) !== -1 && !node.hasChildren) {
        return true;
      }
      return false;
    },

    areaCaChange() {
      const data = this.$refs.areaCascader.getCheckedNodes();
      console.log(data, 'caChange');
      const lastLevelData = data.filter((el) => !el.hasChildren);
      console.log(lastLevelData, 'lastLevelData');
      const tableData = [];
      const valueModel = [];
      lastLevelData.forEach((el) => {
        const obj = {};
        const arr = [];
        obj.categoryId = el.value;
        obj.areaId = el.data.areaId;
        obj.areaName = `${el.parent.label}-${el.data.areaName}`;
        tableData.push(obj);
        valueModel.push(arr);
      });
      // if (tableData.length > 100) {
      //   this.$message.warning('区域数量最多100条');
      //   tableData = tableData.slice(0, 100);
      // }

      this.areaTableData = [...tableData];
      console.log(this.areaTableData, 'this.tableData');
    },
    handleProductChecked(e) {
      if (e) {
        this.$refs.cascader.checkedValue = [];
      }
    },
    handleAreaChecked(e) {
      if (e) {
        this.$refs.areaCascader.checkedValue = [];
      }
    },
    handleCustomerChecked() {
      this.chooseVisible = true;
    },
    closeDialog() {
      this.chooseVisible = false;
    },
    handleQueryCompany(data) {
      console.log(data, 'handleQueryCompany');
      this.supplierCompanyInfo = data;
      this.handleCompanyList(data);
      this.chooseVisible = false;
    },
    handleCompanyList(data) {
      // 组装为XXX公司等xx家 只保留第一家公司名字
      const firstCompany = data[0].companyName;
      const companyList = data.map((item) => item.companyName);
      this.companyListStr = `${firstCompany}等${companyList.length}家`;
    },
  },
};
</script>

<style lang="scss" scoped>
.text-box {
  padding: 11px 10px;
  background: #f4f7ff;
  font-size: 14px;
  font-style: normal;
  font-weight: 350;
  line-height: 24px;
  color: #666;
  margin: 10px 0;
  text-align: center;
}
</style>
